import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import MainApp from './components/routes/MainApp';
import MainApp2 from './components/routes/MainApp2';
import MainApp3 from './components/routes/MainApp3';
import Home from './components/routes/Home';
import LearnerLogin from './components/routes/LearnerLogin';
import LearnerMain from './components/routes/LearnerMain';
import TeacherMain from './components/routes/TeacherMain';
import Update from './components/routes/Update';
import LineDetection from './components/routes/LineDetection';
import BottomDetection from './components/routes/BottomDetection';
import Correct from './components/routes/Correct';
import Suggest from './components/routes/Suggest';
import Suggest2 from './components/routes/Suggest2';
import Test from './components/routes/Test';
import Demo1 from './components/routes/Demo1';
import Demo3 from './components/routes/Demo3';
import Demo4 from './components/routes/Demo4';
import Ex1LearnerLogin from './components/routes/Ex1_2026_LearnerLogin';
import RequireLogin from './components/RequireLogin';
import Ex1LearnerMain from './components/routes/Ex1_2026_LearnerMain';
import Ex1Gaze from './components/routes/Ex1_2026_Gaze';
import Ex1Shape from './components/routes/Ex1_2026_Shape';
import CaptureFigures from './components/routes/CaptureFigures';
import DrawingBuilder from './components/routes/DrawingBuilder';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CameraProvider } from './context/CameraContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <CameraProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/learner-login" element={<LearnerLogin />} />
          <Route path="/learner" element={<LearnerMain />} />
          <Route path="/teacher" element={<TeacherMain />} />
          <Route path="/update" element={<Update />} />
          <Route path="/lineDetection" element={<LineDetection />} />
          <Route path="/viewer" element={<MainApp />} />
          <Route path="/viewer2" element={<MainApp2 />} />
          <Route path='/viewer3' element={<MainApp3/>}/>
          <Route path="/correction" element={<Correct />} />
          <Route path="/suggest" element={<Suggest />} />
          <Route path="/suggest2" element={<Suggest2 />} />
          <Route path="/test" element={<Test />} />
          <Route path="/bottomDetection" element={<BottomDetection />} />
          <Route path='/demo1' element={<Demo1 />} />
          <Route path='/demo3' element={<Demo3 />} />
          <Route path='/demo4' element={<Demo4 />} />
          {/* 番号選択式ログイン。学習者にはこの /login を開いてもらう */}
          <Route path="/login" element={<Ex1LearnerLogin />} />
          <Route path="/ex1-2026-learner-login" element={<Ex1LearnerLogin />} />
          <Route path="/ex1-2026-learner-main" element={<Ex1LearnerMain />} />
          {/* 演習は測定データを番号に紐づけるためログイン必須 */}
          <Route path="/ex1-2026-gaze" element={<RequireLogin><Ex1Gaze /></RequireLogin>} />
          <Route path="/ex1-2026-shape" element={<RequireLogin><Ex1Shape /></RequireLogin>} />
          {/* 研究資料の図版を一括書き出しする開発用ページ（学習者には案内しない） */}
          <Route path="/capture-figures" element={<CaptureFigures />} />
          <Route path="/drawing-builder" element={<DrawingBuilder />} />
        </Routes>
      </Router>
    </CameraProvider>

);